import {AbstractService} from "@/services/AbstractService";
import {HttpRequests} from "@/services/observer/HttpRequests";
import {Pages} from "@/services/observer/Pages";

export class Observer extends AbstractService {
    httpRequests = new HttpRequests();
    pages = new Pages();

    async init() {
        await this.httpRequests.init();
        await this.pages.init();
    };
}